export const SocialMedia = () => {
    return <h1>SocialMedia</h1>
}